import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';

import { getCurrencySymbol } from '../../../collums-components/helpers';

import { withStyles, Typography, Box } from '@material-ui/core';
import { drawerStyles } from './styles';
import { APPOINTMENT_STATUS_TYPES } from '../../../collums-constants';
function AppointmentCourse({
    classes,
    data,
    handleChange,
    form,
    clinic,
    selectedCourse,
    selectedService,
    appointmentLhdIndex,
    linkedAppointments,
    isCoursePerformedByPractitioner,
    isAdditionalService = false,
    customerId
}) {
    const [currentlyTaken, setCurrentlyTaken] = useState(0);

    useEffect(() => {
        const mainForm = form.parentForm ? form.parentForm : form;
        const currentService = data?.course?.service && data?.course?.service[0] && data?.course?.service[0]?.id;
        const currentCourse = data.id;
        let currentlyTaken = 0;
        if (
            mainForm.course === currentCourse &&
            mainForm.service?.id === currentService &&
            mainForm.status !== APPOINTMENT_STATUS_TYPES.COMPLETED &&
            mainForm.status !== APPOINTMENT_STATUS_TYPES.NO_SHOW &&
            !mainForm.checkedIn
        ) {
            currentlyTaken++;
        }

        if (Array.isArray(mainForm.linkedAppointments)) {
            for (const appt of mainForm.linkedAppointments) {
                if (
                    appt.course === currentCourse &&
                    appt.service?.id === currentService &&
                    appt.status !== APPOINTMENT_STATUS_TYPES.COMPLETED &&
                    appt.status !== APPOINTMENT_STATUS_TYPES.NO_SHOW &&
                    !appt.checkedIn
                ) {
                    currentlyTaken++;
                }
            }
        }

        if (
            mainForm.id &&
            selectedService?.id === currentService &&
            mainForm.status !== APPOINTMENT_STATUS_TYPES.COMPLETED &&
            mainForm.status !== APPOINTMENT_STATUS_TYPES.NO_SHOW &&
            !mainForm.checkedIn
        ) {
            currentlyTaken--;
        }
        setCurrentlyTaken(currentlyTaken);
    }, [data, form, selectedService]);

    const coursesColours = {
        availabe: '#00b669',
        reserved: '#ffa012',
        redeemed: '#bf2000',
        disabled: '#69767E'
    };

    // const totalPaid = (() => {
    //     const paymentsTotal =
    //         data.payments?.reduce((acc, element) => {
    //             return acc + parseFloat(element.amount);
    //         }, 0) || 0;

    //     return Number(paymentsTotal) || 1;
    // })();

    const individualCourseData = useMemo(() => {
        const invoiceItems = Array.isArray(data.invoiceItem) ? data.invoiceItem : [data.invoiceItem].filter(Boolean);
        const matchingItem = invoiceItems.find(el => el?.referenceId === data?.course?.id);
        const invoiceAmount = data?.completeInvoice?.amount || 0;
        const invoicePaid = (data.payments || []).reduce((sum, item) => sum + item.amount, 0);
        const paidPercentage = invoiceAmount > 0 ? invoicePaid / invoiceAmount : 1;

        if (matchingItem) {
            const taxedPrice = matchingItem.netPrice + matchingItem.netPrice * matchingItem.tax;
            const itemDiscount = matchingItem.discount || data.discount || 0;
            const discountedPrice = taxedPrice - itemDiscount;

            const PricePercentageInRelationToTotal =
                !data.amount || !discountedPrice ? 0 : (discountedPrice / data.amount) * 100;
            return {
                PricePercentageInRelationToTotal,
                discountedPrice,
                paid: discountedPrice * paidPercentage,
                os: discountedPrice * (1 - paidPercentage)
            };
        }

        if (data.invoiceItem && !Array.isArray(data.invoiceItem)) {
            const taxedPrice = data.invoiceItem.netPrice + data.invoiceItem.netPrice * data.invoiceItem.tax;
            const itemDiscount = data.invoiceItem.discount || 0; // Only use item-level discount, not invoice-level
            const discountedPrice = taxedPrice - itemDiscount;

            const PricePercentageInRelationToTotal =
                !data.amount || !discountedPrice ? 0 : (discountedPrice / data.amount) * 100;
            return {
                PricePercentageInRelationToTotal,
                discountedPrice,
                paid: discountedPrice * paidPercentage,
                os: discountedPrice * (1 - paidPercentage)
            };
        }

        if (data.course) {
            const discountedPrice = parseFloat(data.amount || 0);
            return {
                PricePercentageInRelationToTotal: 100,
                discountedPrice,
                paid: discountedPrice * paidPercentage,
                os: discountedPrice * (1 - paidPercentage)
            };
        }

        return {
            PricePercentageInRelationToTotal: 100,
            discountedPrice: 0,
            paid: 0,
            os: 0
        };
    }, [data]);

    const getAmountPaid = () => {
        return individualCourseData.paid.toFixed(2);
    };

    const getAmountOs = () => {
        return individualCourseData.os.toFixed(2);
    };

    const getAmountEach = () => {
        if (data.additionalServices && data.additionalServices.length) {
            return parseFloat(data.grossAmount / data.quantity).toFixed(2);
        }
        return parseFloat(individualCourseData.discountedPrice / (data?.quantity || 1)).toFixed(2);
    };

    const isIndexRedeemed = index => index + 1 <= data.redeemed;
    const isIndexReserved = index => index + 1 - currentlyTaken <= data.redeemed + data.reserved;

    // index
    const getColor = index => {
        if (!isCoursePerformedByPractitioner) return coursesColours.disabled;
        if (isIndexRedeemed(index)) return coursesColours.redeemed;
        if (isIndexReserved(index)) return coursesColours.reserved;
        return coursesColours.availabe;
    };

    const isClickable = index => {
        if (
            !isCoursePerformedByPractitioner ||
            isIndexRedeemed(index) ||
            isIndexReserved(index) ||
            form.status === APPOINTMENT_STATUS_TYPES.COMPLETED
        )
            return false;
        return true;
    };

    const handleCircleClick = async index => {
        try {
            if (!isClickable(index)) return;
            if (form.checkedIn) return;
            const service = data.course.service[0];
            let duration = service.defaultDuration;
            const practitioner = form.practitioners[0];
            if (practitioner) {
                const location = service.locations.find(element => clinic.id === element.clinic);

                if (location) {
                    const staff = location.staffs.find(el => el.staff === practitioner.id);
                    if (staff) {
                        if (staff.duration) duration = staff.duration;
                    }
                }
            }
            const end = form.event.start.clone().add(duration, 'minutes');
            handleChange({
                ...form,
                course: data.id,
                service: data.course.service[0],
                price: 0,
                event: {
                    start: form.event.start,
                    end
                },
                duration
            });
        } catch (e) {
            console.error(e);
            toastr.error('Something went wrong (code: c0019)');
        }
    };

    const renderAppointmentsCircles = () => (
        <div className={classes.appointmentCircleContainer}>
            {new Array(data.quantity).fill('').map((item, index) => (
                <div
                    key={index}
                    className={classes.appointmentCircle}
                    style={{ cursor: isClickable(index) ? 'pointer' : 'normal', background: getColor(index) }}
                    onClick={() => handleCircleClick(index)}
                >
                    <Typography
                        className={`${classes.indexLabel} ${!isClickable(index) ? classes.indexLabelHover : ''}`}
                    >
                        {index + 1}
                    </Typography>
                </div>
            ))}
        </div>
    );

    const showSelectedLabel = () => {
        return (
            (selectedCourse === data.id &&
                selectedService?.id === data.course?.service?.[0]?.id &&
                appointmentLhdIndex === 0) ||
            (linkedAppointments &&
                linkedAppointments[appointmentLhdIndex - 1]?.course === data.id &&
                linkedAppointments[appointmentLhdIndex - 1]?.service?.id === data.course?.service?.[0]?.id)
        );
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h4">
                    {!isAdditionalService && (
                        <>
                            {data?.course?.additionalServices && data?.course?.additionalServices.length ? (
                                <a
                                    href={customerId ? `/customer/${customerId}/courses` : '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#1a73e8', textDecoration: 'none', fontWeight: 'bold' }}
                                >
                                    Package: {data?.course?.name}
                                </a>
                            ) : (
                                <a
                                    href={customerId ? `/customer/${customerId}/courses` : '#'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#1a73e8', textDecoration: 'none', fontWeight: 'bold' }}
                                >
                                    Course: {data?.course?.name}
                                </a>
                            )}
                            <br />
                        </>
                    )}
                    <span style={{ fontSize: '0.9rem' }}>Service: {(data?.course?.service || [])[0]?.name}</span>
                </Typography>
                {showSelectedLabel() && (
                    <Typography variant="h4" className={classes.selectedLabel}>
                        Selected
                    </Typography>
                )}
            </div>
            {!isCoursePerformedByPractitioner && (
                <Typography variant="h5">Practitioner does not perform this service</Typography>
            )}
            <Box display="flex" flexDirection="row" mt={2}>
                <Box display="flex" flexDirection="column" width="50%" flexGrow={1} className={classes.courseValues}>
                    {!isAdditionalService && (
                        <Box display="flex" mt={'5px'} justifyContent="space-between">
                            <Typography>Amount paid:</Typography>
                            <NumberFormat
                                className={classes.amountPaid}
                                value={getAmountPaid()}
                                fixedDecimalScale
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={getCurrencySymbol()}
                            />
                        </Box>
                    )}
                    <Box display="flex" mt={1} justifyContent="space-between">
                        <Typography>Amount OS:</Typography>
                        <NumberFormat
                            className={`${classes.amountOs} ${getAmountOs() > 0 ? classes.amountOsRed : ''}`}
                            value={getAmountOs()}
                            fixedDecimalScale
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={getCurrencySymbol()}
                        />
                    </Box>
                    <Box display="flex" mt={1} justifyContent="space-between">
                        <Typography>Value each:</Typography>
                        <NumberFormat
                            className={classes.amountPaid}
                            value={getAmountEach()}
                            fixedDecimalScale
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={getCurrencySymbol()}
                        />
                    </Box>
                </Box>
                <Box flexGrow={1} ml={2} width="50%">
                    {renderAppointmentsCircles()}
                </Box>
            </Box>
        </>
    );
}

AppointmentCourse.propTypes = {
    classes: PropTypes.object.isRequired,
    clinic: PropTypes.object.isRequired,
    data: PropTypes.object,
    handleChange: PropTypes.func,
    form: PropTypes.object,
    selectedCourse: PropTypes.string,
    selectedService: PropTypes.string,
    appointmentLhdIndex: PropTypes.number,
    linkedAppointments: PropTypes.array,
    isCoursePerformedByPractitioner: PropTypes.bool,
    isAdditionalService: PropTypes.bool,
    customerId: PropTypes.string
};

const mapStateToProps = state => {
    return {
        selectedCourse: state.drawer.editingAppointment?.course,
        selectedService: state.drawer.editingAppointment?.service,
        linkedAppointments: state.drawer.editingAppointment?.linkedAppointments
    };
};

export default connect(mapStateToProps)(withStyles(drawerStyles)(AppointmentCourse));
